import { render, staticRenderFns } from "./NewsListing.vue?vue&type=template&id=2241732c&scoped=true&"
import script from "./NewsListing.vue?vue&type=script&lang=js&"
export * from "./NewsListing.vue?vue&type=script&lang=js&"
import style0 from "./NewsListing.vue?vue&type=style&index=0&id=2241732c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241732c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListing.vue
// module id = 73
// module chunks = 0